var map = {
	"./2fa.png": 585,
	"./2fa2.png": 5011,
	"./avatars/0.png": 2061,
	"./avatars/1.png": 1801,
	"./avatars/2.png": 37,
	"./avatars/3.png": 1122,
	"./avatars/4.png": 6569,
	"./avatars/5.png": 726,
	"./avatars/6.png": 6178,
	"./avatars/7.png": 2658,
	"./branding/brand-img-dark.png": 2414,
	"./branding/brand-img-light.png": 3428,
	"./branding/brand-img-small.png": 7125,
	"./branding/logo.png": 2744,
	"./currency-rub-1.png": 113,
	"./currency-rub-2.png": 9923,
	"./currency-rub-3.png": 7620,
	"./elements/21.png": 6957,
	"./elements/activity-timeline.png": 65,
	"./elements/iPhone-bg.png": 2727,
	"./enot2.png": 8395,
	"./favicon/logoicon1.png": 8188,
	"./favicon/logoicon2.png": 6905,
	"./favicon/logoicon3.png": 2297,
	"./icons/brands/asana.png": 7202,
	"./icons/brands/behance.png": 7875,
	"./icons/brands/cent.png": 1717,
	"./icons/brands/chrome.png": 119,
	"./icons/brands/dribbble-rounded.png": 9358,
	"./icons/brands/dribbble.png": 5711,
	"./icons/brands/edge.png": 2058,
	"./icons/brands/event-label.png": 3540,
	"./icons/brands/facebook-rounded.png": 7589,
	"./icons/brands/facebook.png": 6498,
	"./icons/brands/figma-label-info.png": 927,
	"./icons/brands/figma-label.png": 1036,
	"./icons/brands/firefox.png": 5895,
	"./icons/brands/github.png": 967,
	"./icons/brands/google.png": 4770,
	"./icons/brands/html-label.png": 2996,
	"./icons/brands/instagram-rounded.png": 2056,
	"./icons/brands/instagram.png": 4357,
	"./icons/brands/mac.png": 3441,
	"./icons/brands/mailchimp.png": 2940,
	"./icons/brands/opera.png": 4495,
	"./icons/brands/python.png": 6106,
	"./icons/brands/react-info.png": 3117,
	"./icons/brands/react-label.png": 4870,
	"./icons/brands/safari.png": 374,
	"./icons/brands/sketch-label.png": 4239,
	"./icons/brands/slack.png": 7871,
	"./icons/brands/social-label.png": 4738,
	"./icons/brands/support-label.png": 2127,
	"./icons/brands/twitter-label.png": 7290,
	"./icons/brands/twitter-rounded.png": 7387,
	"./icons/brands/twitter.png": 2237,
	"./icons/brands/ubuntu.png": 5085,
	"./icons/brands/vue-label.png": 8541,
	"./icons/brands/vue.png": 2618,
	"./icons/brands/windows.png": 8224,
	"./icons/brands/xamarin.png": 884,
	"./icons/brands/xd-label.png": 1028,
	"./icons/misc/3d-illustration.png": 9666,
	"./icons/misc/4-square.png": 1208,
	"./icons/misc/authentication-QR.png": 1126,
	"./icons/misc/card-icon-bag.png": 7490,
	"./icons/misc/card-icon-laptop.png": 7675,
	"./icons/misc/css.png": 9702,
	"./icons/misc/delta-web-app.png": 2766,
	"./icons/misc/doc.png": 5860,
	"./icons/misc/ecommerce-website.png": 2596,
	"./icons/misc/finance-app-design.png": 265,
	"./icons/misc/html.png": 124,
	"./icons/misc/jpg.png": 1266,
	"./icons/misc/js.png": 9210,
	"./icons/misc/leaf-green.png": 4439,
	"./icons/misc/leaf-orange.png": 7809,
	"./icons/misc/leaf-red.png": 4044,
	"./icons/misc/leaf-shadow.png": 3011,
	"./icons/misc/pdf.png": 7646,
	"./icons/misc/ppt.png": 6017,
	"./icons/misc/psd.png": 2881,
	"./icons/misc/search-doc.png": 4385,
	"./icons/misc/search-jpg.png": 6366,
	"./icons/misc/search-xls.png": 669,
	"./icons/misc/txt.png": 9783,
	"./icons/misc/xls.png": 2750,
	"./icons/misc/zip.png": 1245,
	"./icons/payments/0.png": 5029,
	"./icons/payments/1.png": 7495,
	"./icons/payments/2.png": 6445,
	"./icons/payments/american-ex.png": 6759,
	"./icons/payments/amex-cc.png": 61,
	"./icons/payments/amex.png": 1731,
	"./icons/payments/credit-card.png": 926,
	"./icons/payments/diners-cc.png": 7794,
	"./icons/payments/diners.png": 4445,
	"./icons/payments/discover-cc.png": 5308,
	"./icons/payments/discover.png": 1753,
	"./icons/payments/jcb-cc.png": 8016,
	"./icons/payments/jcb.png": 5586,
	"./icons/payments/jcb15-cc.png": 6996,
	"./icons/payments/logo-american-express.png": 5174,
	"./icons/payments/logo-mastercard-small.png": 435,
	"./icons/payments/maestro-cc.png": 1105,
	"./icons/payments/mastercard-cc.png": 3647,
	"./icons/payments/mastercard-info.png": 3361,
	"./icons/payments/mastercard-label.png": 8358,
	"./icons/payments/mastercard.png": 2436,
	"./icons/payments/paypal-primary.png": 2785,
	"./icons/payments/paypal.png": 664,
	"./icons/payments/stripe.png": 8661,
	"./icons/payments/uatp-cc.png": 2654,
	"./icons/payments/unionPay-cc.png": 2358,
	"./icons/payments/visa-cc.png": 5918,
	"./icons/payments/visa-dark.png": 3673,
	"./icons/payments/visa-light.png": 2036,
	"./icons/payments/visa.png": 1167,
	"./icons/payments/wallet.png": 5122,
	"./icons/unicons/briefcase.png": 8435,
	"./icons/unicons/cc-primary.png": 4361,
	"./icons/unicons/cc-success.png": 4234,
	"./icons/unicons/cc-warning.png": 4523,
	"./icons/unicons/chart-success.png": 8892,
	"./icons/unicons/chart.png": 5193,
	"./icons/unicons/computer.png": 5184,
	"./icons/unicons/cube-secondary.png": 3517,
	"./icons/unicons/paypal.png": 7009,
	"./icons/unicons/wallet-info.png": 659,
	"./icons/unicons/wallet.png": 6387,
	"./illustrations/account-settings-security-illustration.png": 2459,
	"./illustrations/add-new-role-illustration.png": 999,
	"./illustrations/add-new-roles.png": 6415,
	"./illustrations/auth-basic-forgot-password-mask-dark.png": 9379,
	"./illustrations/auth-basic-forgot-password-mask-light.png": 531,
	"./illustrations/auth-basic-login-mask-dark.png": 5236,
	"./illustrations/auth-basic-login-mask-light.png": 5403,
	"./illustrations/auth-basic-register-mask-dark.png": 6337,
	"./illustrations/auth-basic-register-mask-light.png": 1494,
	"./illustrations/auth-basic-reset-password-mask-dark.png": 4541,
	"./illustrations/auth-basic-reset-password-mask-light.png": 8992,
	"./illustrations/auth-cover-forgot-password-mask-dark.png": 4174,
	"./illustrations/auth-cover-forgot-password-mask-light.png": 9022,
	"./illustrations/auth-cover-login-mask-dark.png": 3743,
	"./illustrations/auth-cover-login-mask-light.png": 4766,
	"./illustrations/auth-cover-register-mask-dark.png": 8693,
	"./illustrations/auth-cover-register-mask-light.png": 4097,
	"./illustrations/auth-cover-reset-password-mask-dark.png": 2806,
	"./illustrations/auth-cover-reset-password-mask-light.png": 1499,
	"./illustrations/auth-forgot-password-illustration-dark.png": 9640,
	"./illustrations/auth-forgot-password-illustration-light.png": 4514,
	"./illustrations/auth-login-illustration-dark.png": 559,
	"./illustrations/auth-login-illustration-light.png": 4329,
	"./illustrations/auth-register-illustration-dark.png": 7101,
	"./illustrations/auth-register-illustration-light.png": 5430,
	"./illustrations/auth-register-multi-steps-illustration.png": 387,
	"./illustrations/auth-reset-password-illustration-dark.png": 8091,
	"./illustrations/auth-reset-password-illustration-light.png": 8525,
	"./illustrations/auth-two-steps-illustration-dark.png": 3090,
	"./illustrations/auth-two-steps-illustration-light.png": 2790,
	"./illustrations/auth-verify-email-illustration-dark.png": 7581,
	"./illustrations/auth-verify-email-illustration-light.png": 3047,
	"./illustrations/boy-verify-email-dark.png": 5934,
	"./illustrations/boy-verify-email-light.png": 896,
	"./illustrations/boy-with-laptop-dark.png": 8925,
	"./illustrations/boy-with-laptop-light.png": 3507,
	"./illustrations/boy-with-rocket-dark.png": 930,
	"./illustrations/boy-with-rocket-light.png": 9265,
	"./illustrations/card-customers-illustration.png": 6647,
	"./illustrations/card-orders-illustration.png": 7190,
	"./illustrations/card-ratings-illustration.png": 72,
	"./illustrations/card-session-illustration.png": 2846,
	"./illustrations/create-app-modal-illustration-dark.png": 1357,
	"./illustrations/create-app-modal-illustration-light.png": 6038,
	"./illustrations/create-deal-review-complete.png": 1886,
	"./illustrations/faq-illustration.png": 3521,
	"./illustrations/girl-doing-yoga-dark.png": 5374,
	"./illustrations/girl-doing-yoga-light.png": 7435,
	"./illustrations/girl-unlock-password-dark.png": 982,
	"./illustrations/girl-unlock-password-light.png": 1098,
	"./illustrations/girl-verify-password-dark.png": 9135,
	"./illustrations/girl-verify-password-light.png": 6011,
	"./illustrations/girl-with-laptop-dark.png": 5832,
	"./illustrations/girl-with-laptop-light.png": 5921,
	"./illustrations/illustration-daisy-dark.png": 3988,
	"./illustrations/illustration-daisy-light.png": 6941,
	"./illustrations/illustration-john-dark.png": 8065,
	"./illustrations/illustration-john-light.png": 8833,
	"./illustrations/illustration-upgrade-account.png": 2008,
	"./illustrations/misc-bg-dark.png": 8183,
	"./illustrations/misc-bg-light.png": 3941,
	"./illustrations/misc-coming-soon-illustration.png": 8760,
	"./illustrations/misc-coming-soon-object.png": 1323,
	"./illustrations/misc-error-illustration.png": 8283,
	"./illustrations/misc-error-object.png": 3234,
	"./illustrations/misc-not-authorized-illustration.png": 9357,
	"./illustrations/misc-not-authorized-object.png": 5651,
	"./illustrations/misc-server-error-illustration.png": 7354,
	"./illustrations/misc-under-maintenance-illustration.png": 381,
	"./illustrations/misc-under-maintenance-object.png": 6831,
	"./illustrations/money-bag-5654697-4712953.png": 3427,
	"./illustrations/money-baq.png": 3881,
	"./illustrations/page-pricing-standard.png": 826,
	"./illustrations/payment-banknote.png": 6493,
	"./illustrations/pricing-basic.png": 7906,
	"./illustrations/pricing-enterprise.png": 9869,
	"./illustrations/pricing-illustration.png": 4724,
	"./illustrations/pricing-standard.png": 3918,
	"./illustrations/purple-credit-card.png": 995,
	"./illustrations/shopping-girl.png": 1511,
	"./illustrations/trophy.png": 2078,
	"./layouts/layout-collapsed-menu-dark.png": 3471,
	"./layouts/layout-collapsed-menu-light.png": 8999,
	"./layouts/layout-container-dark.png": 4302,
	"./layouts/layout-container-light.png": 1215,
	"./layouts/layout-content-navbar-and-sidebar-dark.png": 360,
	"./layouts/layout-content-navbar-and-sidebar-light.png": 8076,
	"./layouts/layout-content-navbar-dark.png": 2762,
	"./layouts/layout-content-navbar-light.png": 4907,
	"./layouts/layout-fluid-dark.png": 7107,
	"./layouts/layout-fluid-light.png": 2467,
	"./layouts/layout-horizontal-container-dark.png": 8654,
	"./layouts/layout-horizontal-container-light.png": 1589,
	"./layouts/layout-horizontal-fluid-dark.png": 2437,
	"./layouts/layout-horizontal-fluid-light.png": 2423,
	"./layouts/layout-horizontal-without-menu-dark.png": 7526,
	"./layouts/layout-horizontal-without-menu-light.png": 4027,
	"./layouts/layout-without-menu-dark.png": 2694,
	"./layouts/layout-without-menu-light.png": 4106,
	"./layouts/layout-without-navbar-dark.png": 227,
	"./layouts/layout-without-navbar-light.png": 4431,
	"./logo.png": 6338,
	"./logo2.png": 1360,
	"./logoapex.png": 400,
	"./pages/header-dark.png": 1115,
	"./pages/header-light.png": 8137,
	"./pages/profile-banner.png": 9107,
	"./process3.png": 6416,
	"./products/1.png": 6669,
	"./products/2.png": 4680,
	"./products/amazon-echo-dot.png": 4789,
	"./products/apple-iMac-4k.png": 1709,
	"./products/apple-iPhone-13-pro.png": 4432,
	"./products/apple-mac-mini.png": 5133,
	"./products/apple-watch-7.png": 8446,
	"./products/card-accounting-logo.png": 6350,
	"./products/card-apple-iphone-x.png": 1861,
	"./products/card-apple-watch-green.png": 7524,
	"./products/card-marketing-expense-logo.png": 6718,
	"./products/card-ps4-joystick.png": 6443,
	"./products/card-sales-overview-logo.png": 1984,
	"./products/card-weekly-sales-controller.png": 1980,
	"./products/card-weekly-sales-phone.png": 211,
	"./products/card-weekly-sales-watch.png": 3345,
	"./products/dell-inspiron-3000.png": 2708,
	"./products/google-pixel-6.png": 2291,
	"./products/gramin-verve.png": 8248,
	"./products/hp-envy-x360.png": 8120,
	"./products/nintendo-switch.png": 3781,
	"./products/oneplus-9-pro.png": 6756,
	"./products/samsung-s22.png": 8713,
	"./products/samsung-watch-4.png": 8978,
	"./products/sony-play-station-5.png": 7958,
	"./products/sup-game-box-400.png": 4355,
	"./products/xbox-series-x.png": 8780,
	"./sberbank.png": 8528,
	"./test_logo.png": 1588,
	"./tinkoff.png": 3882,
	"./u8lrha0a.png": 1664,
	"./usdt.png": 716,
	"./yandex.png": 8612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;